module.exports = __webpack_public_path__ + "img/second_account_balance.67e6ede4.png";